import React, { Component } from 'react';
import axios from 'axios';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';


import { BaseUrl } from '../common/config';
import Popup from '../common/popup';
import Loader from '../common/loader';
// import CommonAlert from '../common/Commonalert';
// import darkinfo from '../assets/images/dark-info.svg'
// import whiteinfo from '../assets/images/color-info.svg'
// import Cartitem1 from '../assets/images/pcart-item-1.jpg';
// import Cartitem2 from '../assets/images/pcart-item-2.jpg';
// import Cartitem3 from '../assets/images/pcart-item-3.jpg';

import NoImage from '../assets/images/no-image.jpg';
//import CartCommonImage from '../assets/images/prod-icon.png';

class Checkoutfree extends Component {


    constructor(props) {

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }


        super(props);
        this.state = {
            products: [],
            tempproducts: [],
            loading: false,
            searchText: "",
            cartAdded: (localStorage.getItem('cartItems') ? (JSON.parse(localStorage.getItem('cartItems')).length > 0 ? true : false) : false),
            pageTitle: "",
            showCartMessage: false,
            cartMsgType: "",
            cartMessage: "",
            cartSubTotal: 0,
            cartTotal: 0,
            popupVis: false,
            popupImg: false,
            viewImage: "",
            viewInfo: "",
            viewFreeProductInfo: '',
            productImageIndex: "",
            reloadCart: true,
            cartQty: [],
            allergens: ['CELERY', 'CEREALS CONTAINING GLUTEN', 'CERELAS', 'GLUTENS', 'GLUTEN',  'WHEAT', 'BARLEY', 'OATS', 'CRUSTACEANS', 'CRUSTACEAN', 'EGGS', 'EGG', 'FISH', 'LUPIN', 'MILK', 'MOLLUSCS', 'MUSTARD', 'PEANUTS', 'SESAME SEEDS', 'SESAME', 'SOYBEANS', 'SULPHUR DIOXIDE', 'SULPHITES', 'SULPHITE', 'TREE NUTS', 'NUTS', 'WHEAT GLUTEN', 'SOYA', 'CEREALS', 'CEREAL', 'SOY'],
            ingredientsHigh: ['CELERY', 'CEREALS CONTAINING GLUTEN', 'CERELAS',  'GLUTENS', 'GLUTEN', 'WHEAT', 'BARLEY', 'OATS', 'CRUSTACEANS', 'CRUSTACEAN','EGGS', 'EGG', 'FISH', 'LUPIN', 'MILK', 'MOLLUSCS', 'MUSTARD', 'PEANUTS', 'SESAME SEEDS', 'SESAME', 'SOYBEANS', 'SULPHUR DIOXIDE', 'SULPHITES', 'SULPHITE', 'TREE NUTS', 'NUTS', 'PRAWN', 'CRAB', 'LOBSTER', 'MUSSELS', 'OYSTERS', 'ALMONDS', 'HAZELNUTS', 'WALNUTS', 'BRAZIL NUTS', 'CASHEWS', 'PECANS', 'PISTACHIOS', 'MACADAMIA NUTS', 'WHEAT GLUTEN', 'SOYA', 'CEREALS', 'CEREAL', 'SOY'],
            checkedItems:(localStorage.getItem('freeProductIds') !=='' && localStorage.getItem('freeProductIds') !== undefined ? [localStorage.getItem('freeProductIds')] : []),
            checkedItems2:(localStorage.getItem('freeProductIds') !=='' && localStorage.getItem('freeProductIds') !== undefined ? [localStorage.getItem('freeProductIds')] : []),
            offerproducts: [],
            freeProductData:[],
            disableButton:true,
            errorMessage:'',
            common_alert_popup: false,
            common_alert_message: '',
            removeFreeProduct: [],
            removeFreeProductQty:'',
            cartLoader: false,
            freeProductIds: (localStorage.getItem('freeProductIds') !=='' && localStorage.getItem('freeProductIds') !== undefined ? new Array(localStorage.getItem('freeProductIds')) : []),
            freeProductOpen: false,
            delete_item_popup_free: false,
            offerProductQty: '',
            addtoCartTypeQty: 0,
            freeProductQty: 1,
            productValueIndex:[],
            offerproductQtyRemaing: 0,
            decrease_alert_popup: false,
            decreaseItem: [],
            delete_item_alert_popup: false,
            delete_single_Item: [],
            delete_item_alert_message: '',
            removeProduct:[],
            navigate: false,
            minmumAmountError:false,
            cartOriginalTotal: 0,
            imageDetails: '',
            settingsList:[],
            taxProductTotalAmount: 0,
            vatTaxAmount: 0,
            imageHover: false,
            hoverImageUrl: '',
            offerCombineProducts: [],
            offerCombineFreeProducts: [],
            freeProductDataFour: [],
            freeProductDataFive: [],
            freeProductDataFouravailable: false,
            freeProductDataFiveavailable: false,
            minimumOrderAmount: 0,
            accountObjective1: (loginDetails.accountObjective1 !== '' && loginDetails.accountObjective1 > 0  ? parseInt(loginDetails.accountObjective1) : 4),
            accountObjective2: (loginDetails.accountObjective2 !== '' && loginDetails.accountObjective2 > 0  ? parseInt(loginDetails.accountObjective2) : 5),

        };


        this.updateStateValue = this.updateStateValue.bind(this);
        this.handleChangeSearch = this.handleChangeSearch.bind(this);

        if (localStorage.getItem("sitemaintanance") === '1'){
            window.location.href = '/sitemaintanance';
        }else if (!localStorage.getItem("isLoggedIn")){
            window.location.href = '/';
        }

       if (localStorage.getItem("specialofferdisplay") !== 'Yes'){
            window.location.href = '/';
        }


        this.setState({ loading: true });
        this.imgRef  = React.createRef();
        this.paneRef  = React.createRef();
        this.inlineContainerRef = React.createRef();

    }

    componentDidMount() {
        this.offerProduct();
    }

    getSettings(){

     var loginDetails = {};
     if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
     }
     
     let URL = BaseUrl + "settings";
         axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data[0];
            if(responseData !==''){

            this.setState({ settingsList: responseData, minimumOrderAmount: responseData.minimumOrderAmount });
           }
         }).catch((err) => {
            console.log(err);
         });
    }

    updateStateValue() {
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var cartTotal = 0;
        var subTotal = 0;

        if(cartItems !== ''){
        cartItems.map(function (cartItem) {

        if(cartItem.product_type === 'Normal'){
            if (cartItem.qty > 0 ) {
                this.setState({ [cartItem.productNumber]: cartItem.qty, freeProductIds: '' });
                cartTotal += parseFloat(cartItem.PDP_Price1) * cartItem.qty;
                subTotal  += parseFloat(cartItem.PDP_Price1) * cartItem.qty;
            } else {
                //console.log(this.state[cartItem.productNumber]);
                this.setState({ [cartItem.productNumber]: 0});
            }
        }

        }, this);

       var totalAmount = 0;
       var TaxAmount = 0;
       
        if(cartItems !=='' && cartItems !== null){
            cartItems.map((taxItem)=>{
                if(taxItem.productTaxVal > 0){
                    totalAmount += taxItem.PDP_Price1 * taxItem.qty;
                }
            });
        }

        if(totalAmount > 0){
           TaxAmount = (totalAmount/100)*20;  
           cartTotal = cartTotal + TaxAmount;
        }
    
        this.setState({ cartSubTotal: this.priceFormat(subTotal), cartTotal: this.priceFormat(cartTotal), cartOriginalTotal: cartTotal, clear_cart:false, delete_item_popup: false, minmumAmountError: false, taxProductTotalAmount: totalAmount,vatTaxAmount: TaxAmount });

        this.checkOfferProductQty();

        var current = this;

        setTimeout(function(){
            current.setState({cartLoader: false});
        }, 500);

      }
    }

    checkOfferProductQty(){

        var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        if(offerproductsList !== ''){
         // productToBeAdded = offerproductsList.productToBeAdded;
         // stringSplit = productToBeAdded.split(',');
        }
        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;

        var removeProduct = this.state.removeProduct;

        if(offerproductsList !== '' && cartItemsLast !== ''){
         
          cartItemsLast.map((freeItem)=>{
           stringSplit.filter(function(value) {
            if(freeItem.productNumber === value){
                offerProductLastQty += freeItem.qty;
            }
           });
          });

        }

        this.setState({offerProductQty: offerProductLastQty});
    }

    checkIfMultiple(num1, num2) {
      return num1 % num2 === 0;
    }

    CloseFreePopup=()=> {
        this.setState({freeProductOpen:false});
    }


    addFreeProduct(event,checkedprod,freeProduct, productValue, freeProductNew, checkedState){

       event.preventDefault();
       document.getElementById("alert_message").innerHTML = '';
       
       if(checkedprod.length > 0){
        this.setState({checkedItems:checkedprod});
       }

       var condition = 0;
       var inputCount = 0;

        productValue.map((value, index)=>{
           inputCount += value.qty;
        });

       if(inputCount > 0){

        var freeProductList = freeProduct;
        var newitems_new = [];
        var cartItemsList = JSON.parse(localStorage.getItem("cartItems"));
        var freeItems = [];

        freeProductList.data.map((data, index)=>{

            var oldprice = '';
            var productDescriptionText = '';

            var newitems = [];

            var current = this;

            this.updateStateValue();

            var freeQty = 0;
            if(condition === 0){

               var cartItems = JSON.parse(localStorage.getItem("cartItems"));
                   oldprice = data.PDP_Price1;
                   productDescriptionText = data.productDescription;
                   data.PDP_Price1 = '0';
                   data.productDescription = productDescriptionText;

             if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === data.productNumber && cartItem.product_type === 'Free'))) {

                productValue.map((freeItem)=>{
                    if(freeItem.pid === data.productNumber){
                        freeQty = freeItem.qty;
                        freeItems.push(freeItem.pid);
                    }
                });

                newitems = cartItems.map((cartItem) =>
                    cartItem.productNumber === data.productNumber && cartItem.product_type === 'Free'
                        ? {
                            ...cartItem,
                            qty: freeQty
                        }
                        : cartItem
                )

                 localStorage.setItem('cartItems', JSON.stringify(newitems));
                 this.updateStateValue();

               } else {

                productValue.map((freeItem)=>{
                    if(freeItem.pid === data.productNumber){
                        freeQty = freeItem.qty;
                        freeItems.push(freeItem.pid);
                    }
                });


                if (cartItems !== null) {

                    newitems = [...cartItems, { ...data, qty: freeQty, product_type: 'Free' }]
                } else {

                    newitems = [{ ...data, qty: freeQty, product_type: 'Free' }]
                }

              }
 
            newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
            localStorage.setItem('cartItems', JSON.stringify(newitems));
            this.updateStateValue();
            data.PDP_Price1 = oldprice;
            data.productDescription = productDescriptionText;
            localStorage.setItem('freeProductIds', data.productNumber);
            this.setState({ viewFreeProductInfo: '', freeProductOpen:false,freeProductIds: (this.state[data.productNumber] > 0 ? '' :  data.productNumber)});

          }

        });


        localStorage.setItem('freeProductIdsNew', freeItems);

        this.setState({ freeProductIds: freeItems});

        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        if(offerproductsList !== '' && offerproductsList !==''){
           productToBeAdded = offerproductsList.productToBeAdded;
           //stringSplit = productToBeAdded.split(',');
        } 

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductQty = 0;

        if(stringSplit !== ''){
            cartItemsNew.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductQty += cartItem.qty;
                    }
                });
             });   
        }

       }else{
        document.getElementById("alert_message").innerHTML = 'Please select the minimum one item';
       }
    }

    offerProduct(){

    this.setState({ loading: true });

     var loginDetails = {};
     if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
     }

     let URL = BaseUrl + "offerlist";
     axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {

        let responseData = response.data.data[0];

        if(response.data.data.length > 0 && response.data.data.length == '1'){

        let responseDataFour = response.data.data[0];
        var list1 = responseDataFour.freeProductToAdd;
            list1 = list1.split(',');

        var combineArray = list1;
        var offerlist1 = responseDataFour.productToBeAdded;
            offerlist1 = offerlist1.split(',');
        var combineOfferArray = offerlist1;  

        var duplicateArrayRemove = combineArray.filter((item,
        index) => combineArray.indexOf(item) === index);

        var duplicateArrayRemoveOffer = combineOfferArray.filter((item,
        index) => combineOfferArray.indexOf(item) === index);

        this.setState({ offerproducts: responseDataFour, offerCombineProducts: duplicateArrayRemoveOffer, offerCombineFreeProducts: duplicateArrayRemove, freeProductDataFour: list1, freeProductDataFive: []}, function(){
            this.getProductCategories(responseData);
            this.getFreeProductList(responseDataFour, duplicateArrayRemove);
            this.checkOfferProductCount(responseDataFour, duplicateArrayRemoveOffer);
        });

     }else{

        let responseDataFour = response.data.data[0];
        let responseDataFive = response.data.data[1];
        var combineArray = [];

        var list1 = responseDataFour.freeProductToAdd;
            list1 = list1.split(',');

        var list2 = responseDataFive.freeProductToAdd;
            list2 = list2.split(',');

         combineArray = list1.concat(list2);

        var offerlist1 = responseDataFour.productToBeAdded;
            offerlist1 = offerlist1.split(',');
        var offerlist2 = responseDataFive.productToBeAdded;
            offerlist2 = offerlist2.split(',');
        var combineOfferArray = offerlist1.concat(offerlist2);  


        var duplicateArrayRemove = combineArray.filter((item,
        index) => combineArray.indexOf(item) === index);

        var duplicateArrayRemoveOffer = combineOfferArray.filter((item,
        index) => combineOfferArray.indexOf(item) === index);

        this.setState({ offerproducts: responseData, offerCombineProducts: duplicateArrayRemoveOffer, offerCombineFreeProducts: duplicateArrayRemove, freeProductDataFour: list1, freeProductDataFive: list2}, function(){
            this.getProductCategories(duplicateArrayRemoveOffer);
            this.getFreeProductList(responseData, duplicateArrayRemove);
            this.checkOfferProductCount(responseData, duplicateArrayRemoveOffer);
        });
     }


     }).catch((err) => {
        console.log(err);
     });

    }

    getFreeProductList(responseData, duplicateArrayRemove){

        var offerproductsList = responseData;

        if(offerproductsList !==''){

        let productsId = { "$in": duplicateArrayRemove };

        let payload = {
            productIds: productsId,
           // priceband: localStorage.getItem('priceband')
        }

        var loginDetails = {};
         if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        let URL = BaseUrl + "freeproductsbyids";
        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {

            var responseData = response.data.data;

            var current = this;

            responseData.map((item)=>{

                if(current.state.freeProductDataFour.includes(item.productNumber)){   

                    current.setState({freeProductDataFouravailable: true});
                }

                 if(current.state.freeProductDataFive.includes(item.productNumber)){   

                    current.setState({freeProductDataFiveavailable: true});
                }
            });

         this.setState({freeProductData: response.data});

        }).catch((err) => {
        });

      }

    }

    getProductCategories(responseData) {

        var offerproductsList = responseData;
        var productToBeAdded = '';
        var stringSplit = '';
        if(offerproductsList !==''){
          // productToBeAdded = offerproductsList.productToBeAdded;
          // stringSplit = productToBeAdded.split(',');
        }

        this.setState({ loading: true });
        let authData = { accountPriceListId: "" };
        authData = JSON.parse(localStorage.getItem('authData'));
        let productsId = { "$in": responseData };
        let payload = {
            productIds: productsId,
            priceband: localStorage.getItem('priceband')
        }

         var loginDetails = {};
         if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
         }

        let URL = BaseUrl + "productsbyids";
        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {

            let responseData = response.data.data;
            var current = this;
            ///console.log(responseData, 'responseData');
            if(response.data.data.length == 0){

                window.location.href="/home";
            }
            this.setState({ products: responseData });
            this.setState({ tempproducts: responseData });
            this.setState({ loading: false});

        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false })
        })
    }


    priceFormat(price) {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2
        });
    }

    expandCart() {
        var cartTable = document.querySelector('.cart-side-table');
        cartTable.classList.toggle("open");
    }

    freeProductPopupOpen(e){

        e.preventDefault();

        this.setState({minmumAmountError: false});

        var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductLastQty = 0;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        if(offerproductsList !== '' && offerproductsList !==''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }
        
        if(stringSplit !== ''){
            cartItemsFinal.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                })
             });
        }

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var typeFree = 0;

        if(cartItemsNew.some((cartItem) => cartItem.product_type === 'Free')) {
            typeFree = 1;
        }

        let prodlist = this.state.freeProductData.data.map(prd=>{return ({pid:prd.productNumber,qty:0})});

        var offerproductQtyRemaing = 0;

        var productFourqty  = 0;
        var productFiveqty  = 0;

        var totalCount = 0;
        var totalCount1 = 0;

        var calculatedTotal = 0;


         cartItemsNew.map((freeItem)=>{
            var increment = 4;
            var increment1 = 5;

           if(freeItem.product_type === 'Free'){

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = 5;
                productFiveqty = freeItem.qty;
              }else{
                increment = 4;
                productFourqty += freeItem.qty;
              }


              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;

              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });

         if(typeFree === 0){
           offerproductQtyRemaing = offerProductLastQty;
         }

        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        this.setState({freeProductOpen:true, offerProductQty:offerProductLastQty, productValueIndex: prodlist, offerproductQtyRemaing: offerproductQtyRemaing});
    }


   freeProductQtyFour(productQty, item){
    
        var divided_by_4 = productQty / this.state.accountObjective1;
        var firstNum4 = parseInt(divided_by_4);
        return firstNum4;
    }


   freeProductQtyFive(productQty, item){

        var divided_by_4 = productQty / this.state.accountObjective1;
        var divided_by_5 = productQty / this.state.accountObjective2;
        var firstNum4 = parseInt(divided_by_4);
        var firstNum5 = parseInt(divided_by_5);
        
        return firstNum5;    
     }


   freeProductQtyTitle(productQty){

        var divided_by_5 = productQty / this.state.accountObjective5;
        var firstNum5 = parseInt(divided_by_5);
        return firstNum5;    
   }


  checkOfferProductCount(responseData, duplicateArrayRemoveOffer){

        var offerProductLastQty = 0;
        var offerproductsList = responseData;
        var productToBeAdded = '';
        var stringSplit = '';

        if(offerproductsList !== ''){
         // productToBeAdded = offerproductsList.productToBeAdded;
         // stringSplit = productToBeAdded.split(',');
        }

        var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));

        if(duplicateArrayRemoveOffer !== ''){
            cartItemsFinal.map((cartItem) => {
                duplicateArrayRemoveOffer.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                })
             });
        }

        this.setState({offerProductQty: offerProductLastQty}, function(){

        });
    }


    viewProductImage = (i, item) => {
        this.setState({ productImageIndex: i, freeProductOpen: false});
        this.setState({ viewImage: "", freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup:false, minmumAmountError: false})

    }


    handleChange(item, evt) {
        const value = evt.target.value;
        this.setState({ [item.productNumber]: value, freeProductIds: '', freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup: false, minmumAmountError: false});

    }

    handleChangeSearch(value) {
        this.setState({ searchText: value, freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup:false, minmumAmountError: false});
        this.searchProduct(value);

    }

    clearSearch() {
        this.setState({ searchText: "" });
        this.setState({ products: this.state.tempproducts, freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup:false, minmumAmountError: false });
    }

    searchProduct(value) {
        const lowercasedValue = value.toLowerCase().trim();
        const filteredData = this.state.tempproducts.filter((item) => {
            return item.productNumber.toLowerCase().includes(lowercasedValue) || item.productDescription.toLowerCase().includes(lowercasedValue)
        });
        this.setState({ products: filteredData, freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup:false, minmumAmountError: false});
    }

    enablePopup(item) {
        if ((item.productUSP !== null && item.productUSP !== "") || (item.productDiet !== null && item.productDiet !== "") || (item.productIngredient !== null && item.productIngredient !== "") || (item.productSpec !== null && item.productSpec !== "")) {
            return true;
        } else {
            return false;
        }
    }

      validateIntval(e) {
        const re = /[0-9]+/g;
        if (!re.test(e.key)) {
          e.preventDefault();
        }
      }


      popupClose(){

        this.setState({
            common_alert_popup: false, 
            freeProductOpen: false,
            clear_cart:false,
            delete_item_popup: false,
            delete_item_popup_free:false,
            decrease_alert_popup: false,
            delete_item_alert_popup: false,
            minmumAmountError: false
        });

      }

      freeProductClear(){

        var removeFreeProduct = this.state.removeFreeProduct;

        this.removeFreeProduct(this.state.removeFreeProduct);

        this.setState({
            common_alert_popup: false,
        });

      }

      replaceFreeProduct(item){

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var freeProductList = this.state.freeProductData;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = offerproductsList.productToBeAdded;
        var stringSplit = productToBeAdded.split(',');
        var newitems = [];

        var freeProductExist = '0';
        cartItems.map((cartItem) =>{
         if(cartItem.product_type === 'Free'){
             freeProductExist++;
            }
         });


        if(item.product_type === 'Free'){
          newitems = cartItems.filter((cartItem) => (cartItem.product_type !== 'Free'));
          localStorage.setItem('cartItems', JSON.stringify(newitems));
          this.updateStateValue();
        }

      }



    handleImage = (e, item) => {

        this.setState({ cartAdded: false, freeProductOpen:false, clear_cart:false, delete_item_popup: false, common_alert_popup:false, minmumAmountError: false});


        let viewdddImage = "";

        viewdddImage = <Popup
            extClass="prt-poup prt-img-poup show"
            closebtn={<><span onClick={() => this.setState({ viewImage: "" })} className='close'></span></>}
            headMoreTxt={
                <>
                    <div className="order-top">
                        <h4><span>{item.productDescription} ({item.productNumber})</span></h4>

                    </div>
                </>
            }
            bodyMoreTxt={
                <>
                    <div className="prt-bdy-img">
                        <img src={item.productImage !=='' && item.productImage !== null ? item.productImage: NoImage} alt="Product" />
                        <div className="prt-dsc">
                            <span className="pop-prt-txt">{item.productName} </span>
                        </div>
                    </div>
                </>
            }
        />
        this.setState({ productImageIndex: e });
        this.setState({ viewImage: viewdddImage, minmumAmountError: false });
    }

    render() {

        // console.log(this.state.freeProductDataFouravailable, 'freeProductDataFouravailable');
        // console.log(this.state.freeProductDataFiveavailable, 'freeProductDataFiveavailable');



        return (
            <>
                <Header />
               
                {!this.state.loading &&
                    <main className='main-section'>
                    <section className="checkout-block">
                        <div className="sm-container">
                            <div className='checkout-header'>
                                <h1 className='page-title'>FREE Product Information <span>(Pasta, Rice & Noodles)</span></h1>
                                <div className="back-to-cat">
                                    <a className="back-btn" href="/home"><i className="fa fa-arrow-left"></i> Back to Main</a>
                                </div>
                            </div>
                          <div className="free-product-wrap">
                            <div className='free-intro-txt'>
                                <ul>
                                    <li><strong>When you select any {this.state.accountObjective1} sauces</strong> (the same {this.state.accountObjective1} or different) from below you will receive 1 x FREE pasta (see pasta availablity below)</li>
                                    <li><strong>When you select any {this.state.accountObjective2} sauces</strong> (the same {this.state.accountObjective2} or different) from below you will receive 1 x FREE rice (see rice availablity below)</li>
                                    <li><strong>When you select any 10 sauces</strong> you will receive {this.freeProductQtyFour(10)} x FREE pasta or {this.freeProductQtyFive(10)} x FREE rice or a combination of both (see pasta / rice availablity below)</li>
                                </ul>
                            </div>

                            <h5 className='page-title'>Sauces available</h5>
                          
                            <ul className="free-product-list">
                                <li className='prod-list-header'>
                                    <div className="free-prod-id">
                                        <h4>Product</h4>
                                    </div>
                                    <div className="free-prod-unit">
                                        <h4>Unit Of Sale</h4>
                                    </div>
                                    <div className="free-prod-price">
                                        <h4>Price</h4>
                                    </div>
                                </li>

                               {this.state.products.length > 0 && this.state.products.map((item, i) => (
                             <li>
                                <div className="free-prod-id">
                                  <div className="free-prod-img" onClick={(e) => this.handleImage(i, item)} > <img src={item.productImage !=='' && item.productImage !== null ? item.productImage: NoImage} alt={item.productDescription} /> </div>
                                  <div  className="free-prod-title" onClick={(e) => this.handleImage(i, item)}> 
                                  <h4>{item.productDescription} <span> ({item.productNumber})</span> </h4>
                                  </div>
                                </div>
                                <div className="free-prod-unit"><h4>{item.packageSize}</h4></div>
                                <div className="free-prod-price"><h4>{this.priceFormat(item.PDP_Price1 * 1)}</h4>

                               
                                </div>


                               </li>))

                           }

                            </ul>

                            {this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 && this.state.freeProductDataFouravailable === true &&
                            <h5>FREE Pasta available</h5>
                            }

                            {this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 && this.state.freeProductDataFouravailable === true &&

                              <ul className="free-product-list">
                                <li className='prod-list-header'>
                                    <div className="free-prod-id">
                                        <h4>Product</h4>
                                    </div>
                                    <div className="free-prod-unit">
                                        <h4>Unit Of Sale</h4>
                                    </div>
                                    <div className="free-prod-price">
                                        <h4>Price</h4>
                                    </div>
                                 </li>

                                {this.state.freeProductData.data.map((freeItem, freeIndex)=> {
                                 if(this.state.freeProductDataFour.includes(freeItem.productNumber)){    
                                  return( <li>
                                    <div className="free-prod-id">
                                        <div className="free-prod-img" onClick={(e) => this.handleImage(freeIndex, freeItem)}>
                                            <img src={freeItem.productImage !=='' && freeItem.productImage !== null ? freeItem.productImage: NoImage} alt={freeItem.productDescription}  />
                                        </div>
                                        <div  className="free-prod-title"  onClick={(e) => this.handleImage(freeIndex, freeItem)}> 
                                            <h4>{freeItem.productDescription} <span> ({freeItem.productNumber})</span></h4>
                                        </div>
                                    </div>
                                    <div className="free-prod-unit"><h4>{freeItem.packageSize}</h4></div>
                                    <div className="free-prod-price"><h4 className='color-red'><strong>FREE</strong></h4>
                                    </div>
                                </li>) }

                               })
                             }
                            </ul>}
                            
                            {this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 && this.state.freeProductDataFive.length > 0 && this.state.freeProductDataFiveavailable === true && 

                               <h5>FREE Rice available</h5>
                            }

                            {this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 && this.state.freeProductDataFiveavailable === true && 

                            <ul className="free-product-list">
                                <li className='prod-list-header'>
                                    <div className="free-prod-id">
                                        <h4>Product</h4>
                                    </div>
                                    <div className="free-prod-unit">
                                        <h4>Unit Of Sale</h4>
                                    </div>
                                    <div className="free-prod-price">
                                        <h4>Price</h4>
                                    </div>
                                </li>

                                {this.state.freeProductData.data.map((freeItem, freeIndex)=> {
                                if(!this.state.freeProductDataFour.includes(freeItem.productNumber)){    
                                  return( <li>
                                    <div className="free-prod-id">
                                        <div className="free-prod-img" onClick={(e) => this.handleImage(freeIndex, freeItem)}>
                                            <img src={freeItem.productImage !=='' && freeItem.productImage !== null ? freeItem.productImage: NoImage} alt={freeItem.productDescription}  />
                                        </div>
                                        <div  className="free-prod-title"  onClick={(e) => this.handleImage(freeIndex, freeItem)}> 
                                            <h4>{freeItem.productDescription} <span> ({freeItem.productNumber})</span></h4>
                                        </div>
                                    </div>
                                    <div className="free-prod-unit"><h4>{freeItem.packageSize}</h4></div>
                                    <div className="free-prod-price"><h4 className='color-red'><strong>FREE</strong></h4>


                                    </div>
                                </li>) }

                               })}
                            </ul>
                            }

                             {this.state.viewImage != "" && this.state.viewImage}


                           </div>
                        </div>
                    </section>
                    </main>
                }

                {this.state.loading && 
                <main className='main-section'>
                <Loader propsClassName="load-lag" />
                </main>}           

                <Footer />
            </>
        );
    }
}

export default Checkoutfree;